import { FindingType_Numeric } from '@app/advisor-shared';
export function calculateActualValueMap(data) {
    const map = {};
    data.findings.item.toCreate?.forEach(prf => {
        if (prf.isPartialCalculation)
            return;
        switch (prf.type) {
            case 'numeric':
                map[prf.variableId] = prf.value;
                break;
            case 'enumerated':
                if (prf.valueIds?.[0])
                    map[prf.variableId] = prf.valueIds[0];
                prf.attributes?.forEach(att => {
                    if (att.valueIds?.[0])
                        map[att.variableId] = att.valueIds[0];
                });
        }
    });
    data.findings.item.toUpdate?.forEach(ftu => {
        if (ftu.isPartialCalculation)
            return;
        switch (ftu.type) {
            case 'numeric':
                map[ftu.variableId] = ftu.value;
                break;
            case 'enumerated':
                if (ftu.valueIds?.[0])
                    map[ftu.variableId] = ftu.valueIds[0];
                ftu.attributes?.forEach(att => {
                    if (att.valueIds?.[0])
                        map[att.variableId] = att.valueIds[0];
                });
        }
    });
    return map;
}
export function calculateSuggestedValueMap(data) {
    const map = {};
    data.findings.item.toCreate?.forEach(prf => {
        if (!prf.suggestedFinding)
            return;
        if (prf.suggestedFinding.explicitReject || prf.suggestedFinding.userInteracted)
            return;
        switch (prf.suggestedFinding.finding.type) {
            case 'numeric':
                map[prf.variableId] = prf.suggestedFinding.finding.value;
                break;
            case 'enumerated':
                map[prf.variableId] = prf.suggestedFinding.finding.valueIds?.[0];
                prf.suggestedFinding.finding.attributes?.forEach(att => {
                    map[att.variableId] = att.valueIds?.[0];
                });
        }
    });
    return map;
}
export function calculatePartialValueMap(data) {
    return data.partialCalculationFindings.reduce((map, item) => {
        if (item.type === FindingType_Numeric)
            map[item.variableId] = item.value;
        return map;
    }, {});
}
//# sourceMappingURL=utils.js.map